import axios from "axios";

export default {
    actions: {
        async addToFavourite(ctx, productList) {
            if (productList.length > 0) {
                let productList2 = [...productList];
                if (!!productList[0].type) {
                    productList2 = [];
                    productList.forEach(product => {
                        productList2.push({
                            product_id: Number(product.id),
                            name: product.name,
                            photo: product.photo,
                            weight: Number(product.massa),
                            min_price: product.price
                        });
                    });
                }

                const response = await axios
                    .get("/sanctum/csrf-cookie")
                    .then(response => {
                        return axios
                            .post("/api/favourite/add", {
                                ...productList2
                            })
                            .then(res => {
                                if (res.data.status) {
                                    ctx.commit(
                                        "updateFavouriteList",
                                        res.data.data
                                    );
                                    ctx.commit("updateFavouriteTotal");
                                }
                                return res;
                            });
                    })
                    .catch(err => {
                        console.error(err);
                    });
                return response;
            }
        },

        async trashFromFavourite(ctx, productList) {
            const response = await axios
                .get("/sanctum/csrf-cookie")
                .then(response => {
                    return axios
                        .post("/api/favourite/trash", {
                            ...productList
                        })
                        .then(res => {
                            if (res.data.status) {
                                ctx.commit(
                                    "updateFavouriteList",
                                    res.data.data
                                );
                                ctx.commit("updateFavouriteTotal");
                            }
                            return res;
                        });
                })
                .catch(err => {
                    console.error(err);
                });
            return response;
        },

        async fetchAllFavourite(ctx) {
            const response = await axios
                .get("/sanctum/csrf-cookie")
                .then(response => {
                    return axios.get("/api/favourite/show").then(res => {
                        if (res.data.status) {
                            ctx.commit("updateFavouriteList", res.data.data);
                            ctx.commit("updateFavouriteTotal");
                        }
                        return res;
                    });
                })
                .catch(err => {
                    console.error(err);
                });
            return response;
        }
    },

    mutations: {
        updateFavouriteList(state, list) {
            state.list = list;
            this.commit("updateFavouriteTotal");
        },

        updateFavouriteTotal(state) {
            state.total = state.list.length;
        },

        updateFavouriteTotalManually(state, count) {
            state.total = count;
        },

        addFavouriteProduct(state, product) {
            state.list.push(product);
            this.commit("updateFavouriteTotal");
        },

        removeFavouriteProduct(state, product) {
            state.list = state.list.filter(
                oldProduct => oldProduct.id !== product.id
            );
            this.commit("updateFavouriteTotal");
        },

        resetFavourite(state) {
            state.list = [];
            state.total = 0;
        }
    },

    state() {
        return {
            list: [],
            total: 0
        };
    },

    getters: {
        getAllFavourite(state) {
            return state.list;
        },

        getTotalFavourite(state) {
            return state.total;
        }
    }
};
